<template>
    <input class="form-control-plaintext">
</template>

<script>
    export default {
        name: 'FormInputPlaintext'
    }
</script>
